import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Loader, Toast } from '@statsbomb/kitbag-components';

/*
Wrapper component to display a loading state, an error message, or the
children component(s).
*/
function RenderGate({
  children,
  isFetching,
  errorMessage,
  toastBlocksRender,
  onClose,
}) {
  const [isErrorOpen, setIsErrorOpen] = useState(false);

  useEffect(() => {
    setIsErrorOpen(!!errorMessage && !isFetching);
  }, [errorMessage, isFetching]);

  const handleClose = () => {
    setIsErrorOpen(false);
    onClose?.();
  };

  if (isFetching)
    return (
      <div>
        <Loader testId="loader" />
      </div>
    );

  return (
    <>
      {errorMessage && (
        <Toast
          type="error"
          isOpen={isErrorOpen}
          onClose={handleClose}
          testId="error-toast"
        >
          {errorMessage}
        </Toast>
      )}
      {(!errorMessage || !toastBlocksRender) && children}
    </>
  );
}

RenderGate.propTypes = {
  children: PropTypes.node.isRequired,
  errorMessage: PropTypes.string,
  isFetching: PropTypes.bool,
  onClose: PropTypes.func,
  toastBlocksRender: PropTypes.bool,
};

RenderGate.defaultProps = {
  errorMessage: undefined,
  isFetching: false,
  onClose: undefined,
  toastBlocksRender: true,
};

export default RenderGate;
